import React from 'react';
import { Spinner } from 'reactstrap';
import './SpinnerOverlay.scss';
import classnames from 'classnames';

const SpinnerOverlay: React.FC<{ active: boolean }> = ({ active }) => {
  const overlayClasses = classnames('spinner-overlay', { 'active': active });
  return (
    <div className={overlayClasses}>
      <div className="spinner-container">
        <Spinner />
      </div>
    </div>
  )
};

export default SpinnerOverlay;